var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"image-container\">\r\n  <img src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"MainImage") || (depth0 != null ? lookupProperty(depth0,"MainImage") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"MainImage","hash":{},"data":data,"loc":{"start":{"line":2,"column":12},"end":{"line":2,"column":25}}}) : helper)))
    + "\" alt=\"Pack Image\">\r\n</div>";
},"useData":true});